module.exports = __webpack_public_path__ + "static/media/tritech.c649f93a.png";